let serverURL = {};
const moment = require("moment-timezone");

serverURL.s3 = "//2020assets.s3.amazonaws.com";
serverURL.cron = "https://assets.radarr.com/cached_images";
serverURL.cron150 = "https://assets.radarr.com/150gb_cached_images";
serverURL.cron150_1 = "https://assets.radarr.com/150gb_cached_images1";
serverURL.cron_v4 = "https://assets.radarr.com/cached_images_v4";
serverURL.s3v4 = "https://2020assets.s3.amazonaws.com/images";
serverURL.cron4 = "https://2020assets.s3.amazonaws.com/images";
serverURL.cron5 = "https://2020assets.s3.amazonaws.com/images";

let absoluteurl = "http://20twenty.radarr.com";
let allCountries = null;

export function getSparkInfo(data) {
    const info = {};
    info.link = getPostLink(data);
    info.content = getPost(data);
    info.image = getPostImg(data);
    info.title = getPostTitle(data);
    info.author = getPostAuthor(data);
    info._index = data._index;
    info._id = data._id;
    info.isLexisNexisOffline = false;
    if (data._source.platforms[0].short_name === "lexisnexis" && data._source.source_type[0] === "2") {
        info.isLexisNexisOffline = true;
    }
    return info;
}

export function getPostInfo(data, lite_company_id = 0, appliedFilter, thresholdValue) {
    const info = {};

    info.post = getPost(data);
    info.postImg = getPostImg(data);
    info.postAuthorImg = getPostAuthorImg(data);
    info.postTitle = getPostTitle(data);
    info.postAuthor = getPostAuthor(data);
    info.postSentiment = getPostSentiment(data, lite_company_id);
    info.postLink = getPostLink(data);
    info.postMediaType = getPostMediaType(data); // not used anywhere yet
    info.postKloutScore = getPostKloutScore(data);
    info.platformName = getPlatformName(data);
    info.postColor = getPostColor(data);
    info.countries = getCountries(data);
    info.postType = getPostType(data);
    info.tempoTraction = getTempoTraction(data);
    info.tempoFlag = getTempoFlag(data);
    info.domainName = getDomainName(data);
    info.hasParentPost = getHasParentPost(data);
    info.originalUrl = getOriginalUrl(data);
    info.socialIcons = getSocialIcons(data);
    info.likesCount = getPostLikesCount(data);
    info.rate = getEngagementRate(data);
    info.dislikesCount = getDislikesCount(data);
    info.viewsCount = getPostViewsCount(data);
    // info.totalEngagedUsers = getTotalEngagedUsers(data)
    // info.totalReach = getTotalReach(data)
    info.viralityStatus = gerPostViralityStatus(data);
    info.viralityScore = getPostViralityScore(data);
    info.replyCount = getReplyCount(data);
    info.commentsCount = getPostCommentsCount(data);
    info.followersCount = getPostFollowersCount(data);
    info.sharesCount = getPostSharesCount(data);
    info.socialIcons = getSocialIcons(data);
    info.plaformNameTitle = getPlatformNameTitle(data);
    info.postTime = getPostTime(data);
    info.sentimentType = getSentimentType(data, lite_company_id);
    info.postVideoLink = getPostVideoLink(getPlatformName(data), data);
    if (appliedFilter) {
        info.tempoTractionData = showTempoTraction(data, appliedFilter, thresholdValue);
    }

    return info;
}

export function getParentPostInfo(data) {
    const info = {};

    info.post = getParentPost(data);
    info.postAuthorImg = getParentAuthorImg(data);
    info.postAuthor = getParentPostAuthor(data);
    info.postTime = getParentPostTime(data);
    info.likesCount = getParentLikesCount(data);
    info.dislikesCount = getParentDislikesCount(data);
    //info.rate = getParentRate(data)
    //info.totalEngagedUser =getParentTotalEngagedUsers(data)
    //info.totalReach =getParentTotalReach(data)
    info.commentsCount = getParentCommentsCount(data);
    info.sharesCount = getParentSharesCount(data);
    info.followersCount = getParentFollowersCount(data);
    info.viewsCount = getParentViewsCount(data);
    info.postColor = getPostColor(data);
    info.socialIcons = getSocialIcons(data);
    return info;
}

const getTimezoneName = () => {
    return JSON.parse(localStorage.getItem("company")).user_timezone_name;
};

const getPostLikesCount = (data) => {
    return formatNumber(data._source.post.engagement_values.like_count);
};

const getEngagementRate = (data) => {
    if (data && data._source && data._source.post && data._source.post.engagement_values && data._source.post.engagement_values.facebook_engagement) {
        return formatNumber(data._source.post.engagement_values.facebook_engagement.rate);
    } else {
        return 0;
    }
};

const getDislikesCount = (data) => {
    return formatNumber(data._source.post.engagement_values.dislike_count);
};

// const getTotalEngagedUsers = (data) => {
// 	return formatNumber(data._source.post.engagement_values.facebook_engagement.total_engaged_user)
// }

// const getTotalReach = (data) => {
// 	return formatNumber(data._source.post.engagement_values.facebook_engagement.total_reach)
// }

const getPostViralityScore = (data) => {
    const d = parseInt(data._source.impact_prediction_score);
    if (!d) return null;
    else if (d >= 30001 && d < 60000) return `Medium Virality - This post is likely to trend but the probability is not high. Virality score: ${~~d}.`;
    else if (d >= 60001 && d < 100000)
        return `High Virality - This post could spread even faster and is already trending or predicted to trend. Virality score: ${~~d}.`;
    else if (d >= 100001)
        return `Very High Virality - This post is spreading at an accelerated rate and is already trending or predicted to trend. Virality score: ${~~d}.`;
    else return null;
};

const gerPostViralityStatus = (data) => {
    let status = null;
    if (data._source.impact_value >= 30000) {
        status = "trending_now";
    }
    if (data._source.impact_prediction_score >= 50000 && data._source.impact_value < 30000) {
        status = "predicted";
    }
    return status;
};

const getReplyCount = (data) => {
    return formatNumber(data._source.post.engagement_values.reply_count);
};

const getPostCommentsCount = (data) => {
    return formatNumber(data._source.post.engagement_values.comment_count);
};

const getPostSharesCount = (data) => {
    return formatNumber(data._source.post.engagement_values.share_count);
};
const getPostFollowersCount = (data) => {
    let eng = data._source.engagement_data;
    if (!eng) return null;
    if (Array.isArray(eng[0])) eng = data._source.engagement_data[data._source.engagement_data.length - 1];
    return formatNumber(data && data._source && data._source.engagement_data && eng[eng.length - 1].followers);
};

const getPostViewsCount = (data) => {
    return formatNumber(data._source.post.engagement_values.view_count);
};

const gettimediff = (current_date, post_publish_date) => {
    if ((current_date == null || current_date == "") && (post_publish_date == null || post_publish_date == "")) {
        return "";
    }

    if (typeof current_date == "undefined" || typeof post_publish_date == "undefined") {
        return "";
    }

    current_date = current_date.replace(" ", "T");
    post_publish_date = post_publish_date.replace(" ", "T");

    let justnow = "Just now";
    let fewminago = "few minutes ago";
    let minsago = " minutes ago";
    let oneminago = " minute ago";
    let hrsago = " hours ago";
    let onehrago = " hour ago";
    let daysago = " days ago";
    let onedaysago = " day ago";

    let cd = current_date.split("T");
    let today = new Date(cd[0]);
    today.setHours(0, 0, 0, 0);
    today = today.getTime();
    if (isNaN(today)) {
        return 0;
    }

    let pd = post_publish_date.split("T");
    let anotherDate = new Date(pd[0]);
    anotherDate.setHours(0, 0, 0, 0);
    anotherDate = anotherDate.getTime();
    if (isNaN(anotherDate)) {
        return 0;
    }

    let datediff = today - anotherDate;
    if (datediff < 0) {
        return justnow;
    }
    let diff = datediff / 1000; // in seconds
    let daydiff = Math.floor(diff / (60 * 60 * 24)); // in days
    if (daydiff == 0) {
        let today = new Date(current_date);
        today = today.getTime();
        if (isNaN(today)) {
            return 0;
        }
        let anotherDate = new Date(post_publish_date);
        anotherDate = anotherDate.getTime();
        if (isNaN(anotherDate)) {
            return 0;
        }
        let datediff = today - anotherDate;
        if (datediff < 0) {
            return justnow;
        }
        let diff = datediff / 1000; // in seconds
        let secdiff = diff % (60 * 60 * 24);
        // less than a day
        let hrs = Math.floor(secdiff / (60 * 60)); // hrs
        if (hrs == 0) {
            let min = Math.floor(secdiff / 60); // mins
            if (min >= 0 && min <= 10) {
                return justnow;
            } else if (min > 10 && min <= 30) {
                return fewminago;
            } else {
                if (min == "1") {
                    return min + oneminago;
                } else {
                    return min + minsago;
                }
            }
        } else {
            if (hrs == "1") {
                return hrs + onehrago;
            } else {
                return hrs + hrsago;
            }
        }
    } else {
        if (daydiff == "1") {
            let today = new Date(current_date);
            today = today.getTime();

            let anotherDate = new Date(post_publish_date);
            anotherDate = anotherDate.getTime();

            let datediff1 = today - anotherDate;
            if (datediff1 < 0) {
                return daydiff + onedaysago;
            }

            let diff = datediff1 / 1000; // in seconds
            let hrs = Math.floor(diff / (60 * 60)); // hrs

            if (hrs > 23) return daydiff + onedaysago;
            else return hrs + hrsago;
        } else {
            return daydiff + daysago;
        }
    }
};

const getLocalDate = (utc_time) => {
    //local date converted from UTC time zome;
    return moment(utc_time).tz(getTimezoneName()).format("MMMM Do YYYY, h:mm:ss a");
};

// const getLocalDateAgo = (utc_time) => {
//   return gettimediff(moment().utc().format('YYYY-MM-DD HH:mm:ss'), moment(utc_time).utc().format('YYYY-MM-DD HH:mm:ss'));
// }

const getLocalDateAgoNew = (utc_time) => {
    let currentTime = moment().utc(); //todays date
    let postTime = moment(utc_time); // another date

    let duration = moment.duration(currentTime.diff(postTime));
    let hrddiff = duration.asHours().toFixed(0);

    if (hrddiff > 23) return moment(utc_time).tz(getTimezoneName()).format("DD MMM YYYY");
    else return gettimediff(moment().utc().format("YYYY-MM-DD HH:mm:ss"), moment(utc_time).utc().format("YYYY-MM-DD HH:mm:ss"));
};

const getParentLikesCount = (data) => {
    return formatNumber(data._source.parent_post.engagement_like_count);
};

const getParentCommentsCount = (data) => {
    return formatNumber(data._source.parent_post.engagement_comment_count);
};

const getParentSharesCount = (data) => {
    return formatNumber(data._source.parent_post.engagement_share_count);
};

const getParentFollowersCount = (data) => {
    return formatNumber(data._source.parent_post.engagement_followers_count);
};

const getParentViewsCount = (data) => {
    return formatNumber(data._source.parent_post.engagement_view_count);
};

const getParentDislikesCount = (data) => {
    return formatNumber(data._source.parent_post.engagement_dislike_count);
};

// const getParentRate = (data) => {

// }

const getParentPostAuthor = (data) => {
    return data._source.parent_post.author_name;
};

const getOriginalUrl = (data) => {
    return data._source.post.original_url;
};

const getParentPostTime = (data) => {
    return [getLocalDateAgoNew(data._source.parent_post.published_date), getLocalDate(data._source.parent_post.published_date)];
};

const getParentPost = (data) => {
    let data_content = data._source.parent_post.content;
    let textLimit = 350;

    if (data_content === "" || data_content === null) {
        data_content = "";
    }
    if (data_content.length > 350) data_content = data_content.substr(0, textLimit) + "...";
    return data_content;
};

const getParentAuthorImg = (data) => {
    if (data._source.parent_post.author_pic_url === null || data._source.parent_post.author_pic_url === "") return null;
    return data._source.parent_post.author_pic_url;
};

// const getPostMedia = (data) => {
//   let platformName = getPlatformName(data);

//   if (platformName === "youtube") {
//     return "VIDEO";
//   }

//   //Incase image type is text but in other details has video URL
//   if (data._source.post.media.other_details !== null && data._source.post.media.other_details.search('video_url') !== -1) {
//     return "VIDEO";
//   }

//   if (data._source.post.hasOwnProperty('media')) {
//     return data._source.post.media.type;
//   } else {
//     return "TEXT";
//   }
// }

const getPlatformName = (data) => {
    data = data._source;

    return data.platforms[0].full_name;
};

const getPlatformById = (id, data) => {
    for (let platform in data.platforms) {
        if (data.platforms[platform].id === id) {
            return platform;
        }
    }
    return "";
};

/**
 *  Gets the content for the post
 *
 * @returns {string} content
 */
const getPost = (data) => {
    data = data._source;
    var data_content = "";
    var textLimit = 350;

    if (data.post.content !== null && data.post.content !== "" && data.post.content.trim() !== "") {
        data_content = data.post.content;
    } else if (data.post.title !== null && data.post.title.trim() !== "") {
        data_content = data.post.title;
    } else if (data.post_author.name !== null && data.post_author.name.trim() !== "") {
        data_content = data.post_author.name;
    } else {
        data_content = data.post.url;
    }

    if (data_content.length > 350) data_content = data_content.substr(0, textLimit) + "...";
    return data_content;
};

const getPostImg = (data) => {
    if (!isShowImage(data)) return null;

    var platformName = getPlatformName(data);

    if (platformName === "youtube") {
        data = data._source.post.url;

        if (data !== null) {
            let vCode = data.split("v=");
            if (vCode) {
                return "https://img.youtube.com/vi/" + vCode[1] + "/0.jpg";
            } else {
                let media = data._source.post.media[0];
                return getPostImgDetail(media, "post_image");
            }
        }
    } else if (platformName === "youku") {
        return absoluteurl + "/themes/basic/web/images/youku-img.jpg";
    } else {
        let media = data._source.post.media[0];
        return getPostImgDetail(media, "post_image");
    }
};

const isShowImage = (data) => {
    var minWidth = 50;
    var mimHight = 50;
    let mediaObj = data._source.post.media[0];
    if (mediaObj.type !== null && mediaObj.type !== "TEXT" && mediaObj.name !== "") {
        var dimensionsW = mediaObj.dimension_x;
        var dimensionsH = mediaObj.dimension_y;

        if (dimensionsW !== "" && dimensionsW !== null) {
            if (parseInt(dimensionsW, 10) >= minWidth && dimensionsH >= mimHight) {
                return true;
            } else return false;
        }
        return true;
    }
    return false;
};

const isShowAuthorImage = (data) => {
    let postAuthorMediaObj = data._source.post_author.media[0];
    if (postAuthorMediaObj !== null && postAuthorMediaObj !== "") return true;
    else return false;
};

const getPostAuthorImg = (data) => {
    if (!isShowAuthorImage(data)) return null;
    var media = data._source.post_author.media[0];
    return getPostImgDetail(media);
};

const getPostImgDetail = (media) => {
    if (!media.type) {
        return null;
    }

    if (!media.server || !media.name) return null;

    if (media.type.toLowerCase !== "text") {
        if (!media.folder || 0 === media.folder.length) {
            return serverURL[media.server] + "/" + media.name;
        } else {
            var mediaFolder = media.folder;
            mediaFolder = mediaFolder.replace("post_images/post_images", "post_images");
            return serverURL[media.server] + "/" + mediaFolder + "/" + media.name;
        }
    }
};

let getPostTitle = (data) => {
    data = data._source;
    var postTitle = "";
    if (data.post.title === "" || data.post.title === null) {
        postTitle = "";
    } else if (data.post.title.trim() !== "") {
        postTitle = data.post.title;
    }
    return postTitle;
};

const getPostAuthor = (data) => {
    data = data._source;
    var data_content = "";
    var textLimit = 30;

    if (data.post_author.name === "" || data.post_author.name === null) {
        data_content = "";
    } else if (data.post_author.name.trim() !== "") {
        data_content = data.post_author.name;
    }

    if (data_content == "" && data.post_author.username !== "" && data.post_author.username !== null) {
        data_content = data.post_author.username;
    }

    if (data_content.length > textLimit) data_content = data_content.substr(0, textLimit) + "...";
    return data_content;
};

const getPostSentiment = (data, lite_company_id) => {
    let sentimentObj = getSentimentObject(data, lite_company_id);

    return sentimentObj.sentiment;
};

const getPostLink = (data) => {
    if (data._source.platforms[0].id === "27530fd3-fa3e-11e5-83d2-0656fc34e8c9") return absoluteurl + "/factiva?pid=" + data._source.iid;
    else return data._source.post.url;
};

const getPostMediaType = (data) => {
    let platformName = getPlatformName(data);
    let mediaObj = data._source.post.media[0];
    if (platformName === "youtube") {
        return "VIDEO";
    }
    if (mediaObj.other_details && mediaObj.other_details !== null && mediaObj.other_details[0] && mediaObj.other_details[0].name == "video_url") {
        return "VIDEO";
    }
    if (Object.prototype.hasOwnProperty.call(data._source.post, "media")) {
        return mediaObj.type;
    } else {
        return "TEXT";
    }
};

const isKloutScore = (data) => {
    if (!data._source.post_author) return false;
    if (!data._source.post_author.klout_score) return false;
    if (data._source.post_author.klout_score === "10") return false;
    return true;
};

const getPostKloutScore = (data) => {
    return isKloutScore(data) ? data._source.post_author.klout_score : null;
};

const getPostColor = (data) => {
    let platformName = getPlatformName(data);
    switch (platformName) {
        case "facebook":
        case "Facebook":
        case "fbcomment":
        case "FacebookGroup":
        case "Facebook Comments":
            return "#3c5193";
        case "Twitter":
        case "twitter":
            return "#00DBFF";
        case "Vine":
        case "vine":
            return "#02a379";
        case "Instagram":
        case "instagram":
            return "#0086AA";
        case "Blog":
        case "blog":
        case "wordpress":
            return "#FF8B00";
        case "news":
        case "News":
            return "#d62521";
        case "youtube":
        case "Youtube":
            return "#D62521";
        case "NewsOnline":
        case "newsOnline":
            return "#D62521";
        case "LinkedIn":
        case "linkedIn":
            return "#0077B4";
        case "forum":
        case "Forum":
            return "#209F2A";
        case "rating_review":
        case "Rating And Reviews":
            return "#66b500";
        default:
            return "#fb4";
    }
};

export const formatNumber = (number) => {
    if (!number) return null;
    if (Math.floor(number) != number) {
        number = number.toFixed(2);
        return number;
    }
    let decPlaces = 1;
    decPlaces = Math.pow(10, decPlaces);
    let abbrev = ["K", "M", "B", "t"];
    for (let i = abbrev.length - 1; i >= 0; i--) {
        let size = Math.pow(10, (i + 1) * 3);
        if (size <= number) {
            number = Math.round((number * decPlaces) / size) / decPlaces;
            if (number === 1000 && i < abbrev.length - 1) {
                number = 1;
                i++;
            }
            number += abbrev[i];
            break;
        }
    }
    return number;
};

const getCountries = (data) => {
    let platformName = getPlatformName(data);
    data = data._source;
    let countries = [];

    if (["News", "news", "NewsOnline", "newsOnline"].indexOf(platformName) > -1) {
        data.countries.forEach((elem) => {
            countries.push([elem.full_name, elem.short_name]);
        }, this);
    }
    return countries;
};

const getCountryById = (id) => {
    if (!allCountries) allCountries = JSON.parse(localStorage.getItem("filterOptions")).countries;
    let country = allCountries.find((country) => country.id === id);
    return country && country.name !== "Unknown" ? [country.name, country.short_name] : null;
};

const getPostType = (data) => {
    if (isNewsPage(data)) return getNewsType(data);
    else return "";
};

const isNewsPage = (data) => {
    if (data._source.post.entity_sub_type && data._source.post.entity_sub_type === "news") return true;
    return false;
};

const getNewsType = (data) => {
    data = data._source;
    let newsType = "";
    if (data.post.entity_sub_type && data.post.entity_sub_type === "news") {
        if (data.source_type.indexOf(2) > -1 || data.source_type.indexOf("2") > -1) {
            newsType = "offline";
        } else {
            newsType = "online";
        }
    }
    return newsType;
};

const getTempoTraction = (data) => {
    let tt = "";
    if (Object.prototype.hasOwnProperty.call(data._source, "impact_value")) {
        if (data._source.impact_value !== null && data._source.impact_value !== 0) {
            tt += "IMPACT: " + data._source.impact_value;
        }
    }
    if (Object.prototype.hasOwnProperty.call(data._source, "latest_velocity")) {
        if (data._source.latest_velocity !== null && parseFloat(data._source.latest_velocity) !== 0) {
            tt += tt === "" ? "" : ", ";
            tt += "TRACTION: " + data._source.latest_velocity.toFixed(3);
        }
    }
    if (Object.prototype.hasOwnProperty.call(data._source, "alexa_rank")) {
        if (data._source.post.alexa_rank !== null && data._source.post.alexa_rank !== 0) {
            tt += tt === "" ? "" : ", ";
            tt += "Site Rank : " + data._source.post.alexa_rank;
        }
    }
    return tt;
};

const getTempoFlag = (data) => {
    var flag = "flag-grey";
    var impact = 0;
    if (Object.prototype.hasOwnProperty.call(data._source, "impact_value")) {
        if (data._source.impact_value !== null && data._source.impact_value !== 0) {
            impact = data._source.impact_value;
        }
    }
    if (impact >= 300) {
        flag = "flag-red";
    }
    return flag;
};

const getDomainName = (data) => {
    let platformName = getPlatformName(data).toLowerCase();
    if (platformName === "wordpress" || platformName === "blog" || platformName === "forum" || platformName === "news" || platformName === "youku") {
        let input = data._source.post.url;
        let dm = input;
        try {
            dm = decodeURIComponent(dm);
        } catch (e) {
            return "";
        }
        let dmA = dm.split("http://");

        if (!(dmA.length > 2)) {
            dmA = dm.split("https://");
        }

        input = dmA[dmA.length - 1];

        if (!/^(?:f|ht)tps?:\/\//.test(input)) {
            input = "http://" + input;
        }

        let url = input;

        if (url.indexOf("https://www.google.com") >= 0 && getUrlParam("url", url)) {
            url = getUrlParam("url", url);
        }

        if (url.indexOf("google.com") >= 0 && getUrlParam("url", url)) {
            url = getUrlParam("url", url);
        }

        if (url.indexOf("www.bing.com") >= 0 && getUrlParam("url", url)) {
            url = getUrlParam("url", url);
        }

        var a = document.createElement("a");
        a.href = url;
        if (a.hostname.search("api.dowjones.com") !== -1) {
            return "";
        } else {
            return a.hostname;
        }
    } else return "";
};

const getUrlParam = (name, url) => {
    name = name.replace(/[[]/, "\\[").replace(/[\]]/, "\\]");
    let regexS = "[\\?&]" + name + "=([^&#]*)";
    let regex = new RegExp(regexS);
    let results = regex.exec(url);
    return results === null ? null : results[1];
};

const getHasParentPost = (data) => {
    try {
        return data._source.parent_post.id && data._source.parent_post.content ? true : false;
    } catch (e) {
        console.log(data._id);
        return false;
    }
};

const getSocialIcons = (data) => {
    let obj = {};
    obj.totalLike = {};
    obj.comment = {};
    obj.engagementRate = {};
    obj.share = {};
    obj.followers = {};
    obj.virality = {};
    obj.totalDislike = {};
    obj.totalViews = {};

    obj.totalLike.show = true;
    obj.totalLike.img = "likeIcon";
    obj.totalLike.name = "Likes";

    obj.totalDislike.show = true;
    obj.totalDislike.img = "dislikeIcon";
    obj.totalDislike.name = "Dislikes";

    obj.totalViews.show = true;
    obj.totalViews.img = "viewsIcon";
    obj.totalViews.name = "views";

    obj.comment.show = true;
    obj.comment.img = "chatIcon";
    obj.comment.name = "Comments";

    obj.followers.show = true;
    obj.followers.img = "followersIcon";
    obj.followers.name = "Followers";

    obj.engagementRate.show = true;
    obj.engagementRate.img = "engagementIcon";
    obj.engagementRate.name = "EngagementRate";

    obj.share.show = true;
    obj.share.img = "shareIcon";
    obj.share.name = "Share";

    obj.virality.show = true;
    obj.virality.img = "viralIcon";
    obj.virality.name = "Virality";

    let platformName = getPlatformName(data);

    if (platformName === "twitter") {
        obj.totalLike.img = "twitterLikeIcon";
        obj.share.img = "shareIcon";
        obj.share.name = "Retweet";
        obj.comment.show = false;
    }
    return obj;
};

export const getPostTime = (data) => {
    return [getLocalDateAgoNew(data._source.post.published_date), getLocalDate(data._source.post.published_date), data._source.post.published_date];
};

const getPlatformNameTitle = (data) => {
    let pn = getPlatformName(data);

    if (pn === "fbcomment")
        if (data._source.handlers_name) return "FB Comment - " + data._source.handlers_name;
        else return "FB Comment - " + data._source.handlers;

    if (pn === "wordpress") return "blog";

    return pn;
};

const getSentimentObject = (data, lite_company_id) => {
    let genericSentiment = data._source.sentiments[0];
    for (var i = 0; i < data._source.sentiments.length; i++) {
        if (parseInt(data._source.sentiments[i].company_id) === 0) genericSentiment = data._source.sentiments[i];
        if (parseInt(lite_company_id) === parseInt(data._source.sentiments[i].company_id)) {
            return data._source.sentiments[i];
        }
    }
    return genericSentiment;
};

const getSentimentType = (data, lite_company_id) => {
    let sentimentObj = getSentimentObject(data, lite_company_id); // change for company specific
    return `${getPostSentiment(data, lite_company_id)} ${
        sentimentObj.source === 2 || sentimentObj.source === 3 ? "System sentiment" : sentimentObj.source ? "User sentiment" : "Not defined"
    }`;
};

export const getMarkIrrPopupUrl = (data) => {
    var postLinkURL = getPostLink(data);
    var platform = Object.keys(data._source.platforms)[0];
    /*
			url always has post url and not the user url but we have to block user url, so getting user url from post url.
		   */
    if (platform === "facebook") {
        if (postLinkURL.indexOf(data._source.post_author.username) >= 0) {
            postLinkURL = "https://www.facebook.com/" + data._source.post_author.username;
        } else {
            let urlArr = postLinkURL.split("_"); //don't put slash at the end
            postLinkURL = urlArr[0];
        }
    }

    if (platform === "instagram") {
        postLinkURL = "https://www.instagram.com/" + data._source.post_author.username; //don't put slash at the end
    }

    if (platform === "twitter") {
        postLinkURL = "http://twitter.com/" + data._source.post_author.username;
    }

    if (platform === "blog" || platform === "news") {
        postLinkURL = getDomainName(data);
    }
    return postLinkURL;
};

const getPostVideoLink = (platformName, data) => {
    if (getPostMediaType(data) !== "VIDEO") return undefined;

    let mediaObj = data._source.post.media;
    if (platformName == "Dailymotion") {
        data = data._source.post.url;
        let n = data.search(".com/video/");
        if (n > 1) {
            var vCode = data.split(".com/video/");
            if (vCode) {
                vCode = "http://www.dailymotion.com/embed/video/" + vCode[1] + "&api=postMessage&";
            } else {
                vCode = data;
            }
            return vCode;
        } else {
            return data;
        }
    } else if (mediaObj[0].other_details[0] && mediaObj[0].other_details[0] != null /* && mediaObj.other_details.search('video_url') != -1 */) {
        return mediaObj[0].other_details[0].value;
        //let vidURL = JSON.parse(mediaObj.other_details);
        //return vidURL.video_url;
    } else {
        data = data._source.post.url;
        if (data != null) {
            vCode = data.split("v=");
            if (vCode) {
                vCode = "//www.youtube.com/embed/" + vCode[1] + "?";
            } else {
                vCode = data;
            }
            return vCode;
        }
        return data;
    }
};

const timePredictedForViral = (data) => {
    let impactPredictionScore = data._source.impact_prediction_score;
    let impactValue = data._source.impact_value;
    let latestVelocity = data._source.latest_velocity;
    let timeToGoViral = (impactPredictionScore - impactValue) / latestVelocity;
    return timeToGoViral;
};

const getVelocityPostData = (post) => {
    let postVelocity = [];
    if (Object.prototype.hasOwnProperty.call(post._source, "engagement_data")) {
        if (post._source.engagement_data != null) {
            let vdata = post._source.engagement_data;
            if (vdata.length >= 2) {
                postVelocity = post._source.engagement_data;
            }
        }
    }
    return postVelocity;
};

const showTempoTraction = (data, appliedFilter, thresholdValue) => {
    let postVelocityData = getVelocityPostData(data);
    let timeToGoViral = timePredictedForViral(data);
    if (postVelocityData.length <= 1) {
        return false;
    }
    let is_nonzero_impact_available = false;
    for (var i = 0; i < postVelocityData.length; i++) {
        if (postVelocityData[i].impact > 0) {
            is_nonzero_impact_available = true;
            break;
        }
    }
    if (!is_nonzero_impact_available) {
        return false;
    }
    return getTempoTractionData(data._source.post.published_date, postVelocityData, appliedFilter, thresholdValue, timeToGoViral);
};

const getTempoTractionData = (postPublishedDate, postVelocityData, appliedFilter, thresholdValue, timeToGoViral) => {
    let dates = [postPublishedDate];
    let impact = [0];
    let traction = [0];
    let viralChartInfo = {
        orgThresholdValue: thresholdValue,
        wentViralOn: "",
        aboutToViralOn: timeToGoViral,
    };

    for (let data in postVelocityData) {
        if (data === 1) continue;
        let nextDate = postVelocityData[data].published_date || dates[dates.length - 1];
        let nextImpact = postVelocityData[data].impact || impact[impact.length - 1];
        let nextTraction = postVelocityData[data].velocity || traction[traction.length - 1];
        if (nextImpact >= thresholdValue && viralChartInfo.wentViralOn == "") {
            viralChartInfo.wentViralOn = nextDate;
        }
        if (
            appliedFilter.filter_data.duration === "custom" &&
            !appliedFilter.filter_data.rollingDate &&
            moment(nextDate) <= moment(appliedFilter.filter_data.endDateTime)
        ) {
            dates.push(nextDate);
            impact.push(nextImpact);
            traction.push(nextTraction);
        } else if (appliedFilter.filter_data.duration !== "custom" || appliedFilter.filter_data.rollingDate) {
            dates.push(nextDate);
            impact.push(nextImpact);
            traction.push(nextTraction);
        }
    }
    if (appliedFilter.filter_data.duration !== "custom" || appliedFilter.filter_data.rollingDate) {
        dates.push(new Date());
        impact.push(impact[impact.length - 1]);
        traction.push(traction[traction.length - 1]);
    } else {
        dates.push(new Date(appliedFilter.filter_data.endDateTime));
        impact.push(impact[impact.length - 1]);
        traction.push(traction[traction.length - 1]);
    }
    return { dates, impact, traction, viralChartInfo };
};

export const getHighlightText = (text, search_text) => {
    if (search_text != "" && typeof search_text !== "undefined") {
        search_text = search_text.toLowerCase();
        var re1 = /"(.*?)"/gim; //double quote extract word
        let match_strings = search_text.match(re1);
        search_text = search_text.replace(re1, "");

        var sgmatch = Array();
        if (match_strings != null) {
            for (var x = 0; x < match_strings.length; x++) {
                sgmatch[x] = match_strings[x].replace(/["]/gi, "");
            }
        }

        var re3 = /~[0-9]+/g; //Removing minus keywords
        search_text = search_text.replace(re3, "");

        var re = /(^| )(-\w+)/g; //Removing minus keywords
        search_text = search_text.replace(re, "");

        var re0 = /(,)/g;
        search_text = search_text.replace(re0, " "); //changing comma to space in keywords

        var re2 = /[^\w\s-_#@]/gi; //Removing other special char
        search_text = search_text.replace(re2, "").trim();

        search_text = search_text.split(" ");
        search_text = search_text.concat(sgmatch);

        for (let i = 0; i < search_text.length; i++) {
            search_text[i] = search_text[i].trim();
            search_text[i] = search_text[i].replace(/[?]+/g, "");
            search_text[i] = search_text[i].replace(/[.]+/g, "");
        }

        search_text = search_text.filter(function (item, pos) {
            return search_text.indexOf(item) == pos;
        });

        for (let i = 0; i < search_text.length; i++) {
            if (search_text.length > 1) {
                if (search_text[i] === "and" || search_text[i] === "or" || search_text[i] === "not" || search_text[i] === "near" || search_text[i] === "")
                    continue;
            }

            if (search_text[i].length > 1) {
                var patt_good = 1;
                try {
                    var patt = new RegExp("(" + search_text[i] + ")", "gi");
                } catch (err) {
                    patt_good = 0;
                }

                if (patt_good == 1) {
                    text = text.replace(new RegExp("(" + search_text[i] + ")", "gi"), '<span class="highlight">$1</span>');
                }
            }
        }
    }
    return text;
};
